<template lang="pug">
  .products
    .background-header
      v-container.white.pa-0(style="max-width:600px")
        v-row.pa-4(no-gutters align="center")
          v-col
            v-text-field(v-model="searchText" :placeholder = "$t('search_product')" hide-details dense outlined height="40" background-color="basic200" clearable)
              template(v-slot:append)
                eva-icon(v-if="!searchText" name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600" )
          v-col.pl-4.shrink(v-if="member.role === 'Admin'")
            v-menu(bottom left offset-y)
              template(v-slot:activator='{ on }')
                v-btn.elevation-0.pa-0(data-v-step='TourOrderListView-2' color="transparent" small icon v-on='on')
                  eva-icon(name="settings-outline" :fill="$vuetify.theme.themes[$theme].primary400" height="23" style="margin-top: 2px")
              v-list.pa-0(width="250")
                .weight
                  .header.basic300.pa-2
                    .c1 {{ $t('bulk_settings') }}
                  .content.pa-3.clickable(@click="showSetProductWeightDialog = true")
                    .s2 {{ $t('set_weight') }}
                .notes
                  .header.basic300.pa-2
                    .c1 {{ $t('advanced_setup') }}
                  .content.d-flex.pa-3.clickable(@click="showProductNotesDialog = true")
                    .s2 {{ $t('product_notes') }}
                    v-spacer
                    v-chip.button-AA-tiny(small color="info400" dark) {{ $t('new') }}!
        div.mb-2.mx-4(v-if="member.role === 'Admin'")
          div.d-flex.align-center
            v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="clickAddProduct")
              eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
              | {{ $t('create_new_product') }}
      v-container.white.py-2.px-4(style="max-width: 600px")
        v-layout
          div(style="width: 36px")
            y-checkbox.pa-0.mx-0(style="margin-top: 9px;" v-model="selectAll")
          v-spacer
          template(v-if="selectedProducts.length > 0")
            v-menu(offset-y)
              template(v-slot:activator="{ on }")
                v-btn.label.px-0.mr-2(color="transparent" text v-on="on")
                  eva-icon.mt-1.mr-1(name="external-link-outline" :fill=" $vuetify.theme.themes[$theme].textColorAccent" width="14")
                  div.textColorAccent--text {{ $t('actions') }}
              v-list(dense)
                v-list-item(@click="openDeleteDialog = true")
                  v-list-item-title.s2.basic800--text {{ $t('delete_selected') }}
                v-list-item(@click="openUpdateStatusDialog = true")
                  v-list-item-title.s2.basic800--text {{ $t('inactive_selected') }}
      v-container.py-2.px-4.pa-0.mb-4(style="max-width:600px")
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        .contain-layout(v-else)
          v-layout.my-6(v-if="products.length == 0")
            v-row.fill-height.ma-0(align='center' justify='center')
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                p.caption {{ $t('products_not_found') }}
          .items-layout(v-else)
            v-divider.basic300
            template(v-for='product in products')
              product-item.pa-0.mx-0(:parentProduct.sync="product" type="list" :key="product.id" :selectAll="selectAll" @deleted="handleDeleteItem" :setweight="weightRequired" :setdimension="dimensionRequired" @status="product.status = $event" @edited="handleEditItem" @duplicated="handleItemDuplicated")
              v-divider.basic300
        y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

    .modals
      add-product(v-if="showAddProductDialog" :open.sync="showAddProductDialog" @added="handleAddItem" :setweight="weightRequired" :setdimension="dimensionRequired")
      set-product-weight(v-if="showSetProductWeightDialog" :open.sync="showSetProductWeightDialog" :company="company")
      set-product-notes(v-if="showProductNotesDialog" :open.sync="showProductNotesDialog" :company="company")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_items') }}
          v-card-text.p2.primary500--text.px-4
            div(v-if="selectedProducts.length > 1") {{ $t('delete_items_description', { text: 'these items? These items'} ) }}
            div(v-else) {{ $t('delete_items_description', { text: 'this item? This item'} ) }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='bulkStartDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}
      y-dialog(v-if="openUpdateStatusDialog" v-model='openUpdateStatusDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('update_items') }}
          v-card-text.p2.primary500--text.px-4
            div(v-if="selectedProducts.length > 1") {{ $t('update_items_description', { text: 'these items? These items'} ) }}
            div(v-else) {{ $t('update_items_description', { text: 'this item? This item'} ) }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openUpdateStatusDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='bulkUpdateProductStatus' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('update') }}
</template>

<script>
import { mapState } from 'vuex'
import queryString from 'query-string'
import AddProduct from '@/components/dialogs/AddProduct.vue'
import ProductItem from '@/components/ProductItem.vue'
import WCProductSyncAlert from '@/components/ecommerce/woocommerce/WoocommerceProductSyncAlert.vue'
import SetProductWeight from '@/components/dialogs/SetProductWeight.vue'
import SetProductNotes from '@/components/productnotes/dialogs/SetProductNotes.vue'

export default {
  name: 'Products',
  components: { AddProduct, ProductItem, WCProductSyncAlert, SetProductWeight, SetProductNotes },
  props: ['company', 'menu'],
  data: () => ({
    isFetching: false,
    showAddProductDialog: false,
    showProductNotesDialog: false,
    showSetProductWeightDialog: false,
    isTyping: false,
    selectedStyle: 0,
    pageSize: 10,
    count: 0,
    page: 1,
    products: [],
    searchText: '',
    searchCountDown: null,
    weightRequired: false,
    selectAll: false,
    openDeleteDialog: false,
    openUpdateStatusDialog: false,
    newStatus: {},
    loadingCount: 0,
    totalLoadingCount: 0,
    isLoading: false,
    dimensionRequired: false
  }),
  computed: {
    ...mapState('user', ['member']),
    selectedProducts () {
      return this.products.filter(f => f.selected)
    }
  },
  mounted () {
    if (!this.$route.query.page) {
      this.fetchProducts(1)
    } else {
      this.fetchProducts(this.$route.query.page)
    }
    this.fetchRequiredField()
    if (this.$route.query && this.$route.query.show_product_notes === 'true') {
      setTimeout(() => {
        this.showProductNotesDialog = true
      }, 1000)
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    },
    loadingCount (val) {
      if (val) {
        if (val === this.totalLoadingCount) {
          if(this.openUpdateStatusDialog){
            this.fetchProducts(1)
          }
          this.isLoading = false
          this.openUpdateStatusDialog = false
          this.openDeleteDialog = false
          this.newStatus = {}
          this.totalLoadingCount = 0
        }
      }
    },
    totalLoadingCount (val) {
      if (!val) {
        this.loadingCount = 0
      }
    }
  },
  methods: {
    fetchRequiredField () {
      this.$axios.get(`/shipping/settings/${this.company.slug}`)
        .then(resp => {
          this.weightRequired = resp.data.weight_required
          this.dimensionRequired = resp.data.dimension_required
        }).catch(() => {})
    },
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/products/?page=${page}&page_size=${this.pageSize}&company=${this.company.id}&bundle=false&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.count = response.data.count
      }).catch(() => {})
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    searchItem () {
      let searchUrl = `/products/?page=1&page_size=${this.pageSize}&company=${this.company.id}&bundle=false&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.products = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleDeleteItem (item) {
      this.products = this.products.filter((x) => x.id !== item.id)
    },
    handleAddItem (item) {
      this.products.splice(0, 0, item)
    },
    handleItemDuplicated (item) {
      this.products.splice(0, 0, item)
    },
    handleEditItem (item) {
      let editIndex = 0
      this.products.forEach((product, index) => {
        if (product.id === item.id) {
          editIndex = index
        }
      })
      this.products = this.products.filter((x) => x.id !== item.id)
      this.products.splice(editIndex, 0, item)
    },
    bulkStartDelete () {
      this.isLoading = true
      this.totalLoadingCount = this.selectedProducts.length
      this.selectedProducts.forEach(o => {
        this.axios
          .patch(`/products/${o.id}/`, { deleted: true })
          .then(resp => {
            this.$emit('deleted', o)
            this.products = this.products.filter(x => x.id !== resp.data.id)
          })
          .catch(error => {
            // Handling bundle error
            if (error.response) {
              const { data } = error.response
              if (data.code && data.code === 'BUNDLE_EXCEPTION') {
                this.errorBundles = data.bundles
                this.openWarningDialog = true
                this.openDeleteDialog = false
                return
              }
            }
            // Everything else
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loadingCount++
          })
      })
    },
    bulkUpdateProductStatus() {
      this.isLoading = true
      this.totalLoadingCount = this.selectedProducts.length
      this.selectedProducts.forEach(o => {
        let status = ''
        if (o.status == 'draft') {
          status = 'published'
        } else {
          status = 'draft'
        }
        this.$axios
          .patch(`/products/${o.id}/`, { status: status })
          .then(() => {
            this.$emit('status', status)
          })
          .catch(error => {
            // Handling bundle error
            if (error.response) {
              const { data } = error.response
              if (data.code && data.code === 'BUNDLE_EXCEPTION') {
                this.errorBundles = data.bundles
                this.openWarningDialog = true
                this.product.status = 'published'
                this.switchKey++
                return
              }
            }
            // Everything else
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.loadingCount++
          })
      })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "bulk_settings": "Bulk settings",
    "set_weight": "Set weight",
    "advanced_setup": "Advanced setup",
    "new": "New",
    "create_new_product": "create new product",
    "show_details": "Show details",
    "hide_details": "Hide details",
    "search_product": "search product",
    "actions": "actions",
    "delete_items": "Delete Items",
    "delete_items_description": "Are you sure you want to delete this item? This item will be deleted permanently.",
    "inactive_selected": "Inactive selected",
    "update_items": "Update Items",
    "update_items_description": "Are you sure you want to update this item?"
  },
  "id": {
    "bulk_settings": "Pengaturan Massal",
    "set_weight": "Set Berat",
    "advanced_setup": "Konfigurasi Lanjutan",
    "new": "Baru",
    "create_new_product": "Tambah Produk Baru",
    "show_details": "tampilkan detail",
    "hide_details": "sembunyikan detail",
    "search_product": "Cari Produk",
    "actions": "Tindakan",
    "delete_items": "Hapus item",
    "delete_items_description": "Anda yakin ingin menghapus item ini? Item ini akan dihapus secara permanen.",
    "inactive_selected": "Nonaktifkan yang dipilih",
    "update_items": "Perbarui Status item",
    "update_items_description": "Anda yakin ingin memperbarui status item ini?"
  },
  "ms": {
  }
}
</i18n>